"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidthRichSelectCellEditor = void 0;
const richSelectCellEditor_1 = require("@ag-grid-enterprise/rich-select/dist/es6/richSelect/richSelectCellEditor");
class WidthRichSelectCellEditor extends richSelectCellEditor_1.RichSelectCellEditor {
    init(params) {
        super.init(params);
        this.addCssClass(params.classes);
    }
}
exports.WidthRichSelectCellEditor = WidthRichSelectCellEditor;
exports.default = WidthRichSelectCellEditor;
